import { render, staticRenderFns } from "./JsryzcxxbgBrowse.vue?vue&type=template&id=5f593c96"
import script from "./JsryzcxxbgBrowse.vue?vue&type=script&lang=js"
export * from "./JsryzcxxbgBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports